import React from 'react';
import { Globe, CreditCard, Wallet, MoveRight } from 'lucide-react';
import '../../../../../styles/components/auction-enrollment.scss';
import { OMR } from '../../../../common/icons';
import { EnrollmentList } from './AuctionEnrollment/EnrollmentList';

class CashFlowTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animateCharts: false,
      showTransaction: false,
      method: null,
    };
  }

  componentDidMount() {
    // Trigger animation on mount
    setTimeout(() => {
      this.setState({ animateCharts: true });
    }, 100);
  }

  showPaymentHistory = (method) => {
    this.setState({ showTransaction: true, method });
  };

  render() {
    const { search, data, totalCount = 0, totalAmount = 0 } = this.props;

    const renderIcon = (iconType) => {
      switch (iconType) {
        case 'globe':
          return <Globe size={20} />;
        case 'creditCard':
          return <CreditCard size={20} />;
        case 'wallet':
          return <Wallet size={20} />;
        default:
          return <Globe size={20} />;
      }
    };

    const formatNumber = (value) => {
      return new Intl.NumberFormat('en-US').format(value);
    };
    const { showTransaction, method } = this.state;
    return (
      <div className="table-section">
        {/* Table Header */}
        <div className="table-header">
          <div className="column payment-method">PAYMENT METHOD</div>
          <div className="column count">COUNT</div>
          <div className="column amount">AMOUNT</div>
          {/* <div className="column percentage">% OF TOTAL</div> */}
          <div className="column action">ACTION</div>
        </div>

        {/* Table Rows */}
        <div className="table-body">
          {data.map((row, index) => (
            <div key={row.id} className="table-row">
              <div className="column payment-method">
                <div className="method-content">
                  <div className="method-icon" style={{ backgroundColor: `${row.color}15` }}>
                    <span style={{ color: row.color }}>{renderIcon(row.icon)}</span>
                  </div>
                  <span className="method-name">{row.method}</span>
                </div>
              </div>

              <div className="column count">
                <span className="count-value">{formatNumber(row.count)}</span>
              </div>

              <div className="column amount">
                <div className="amount-content">
                  <span className="amount-value" style={{ color: row.color }}>
                    {row.amount}
                  </span>
                  <div className="amount-icon">
                    <OMR size={10} color={row.color} />
                  </div>
                </div>
              </div>

              {/* <div className="column percentage">
                <div className="percentage-content">
                  <div className="percentage-bar">
                    <div
                      className="percentage-fill"
                      style={{
                        width: `${row.percentage}%`,
                        backgroundColor: row.color,
                        animation: this.state.animateCharts
                          ? `growWidth 0.8s ease-out 0.${index * 2}s both`
                          : 'none',
                      }}
                    ></div>
                  </div>
                  <span className="percentage-text">{row.percentage}%</span>
                </div>
              </div> */}
              <div className="column action">
                <button className="action-row" onClick={() => this.showPaymentHistory(row.method)}>
                  <span className="action-row__text">Details</span>
                  <MoveRight className="action-row__icon" size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Total Row */}
        <div className="table-footer">
          <div className="total-row">
            <div className="column payment-method">
              <span className="total-label">TOTAL</span>
            </div>
            <div className="column count">
              <span className="total-value">{formatNumber(totalCount)}</span>
            </div>
            <div className="column amount">
              <span className="total-value">
                {totalAmount} <OMR size={10} color={'#1b8f9b'} />
              </span>
            </div>
            {/* <div className="column percentage">
              <span className="total-value">100%</span>
            </div> */}
            <div className="column action">
              <button className="action-row primary" onClick={() => this.showPaymentHistory(null)}>
                <span className="action-row__text">All</span>
                <MoveRight className="action-row__icon" size={18} />
              </button>
            </div>
          </div>
        </div>

        <EnrollmentList
          show={showTransaction}
          search={search}
          method={method}
          onClose={() => this.setState({ showTransaction: false, method: null })}
        />
      </div>
    );
  }
}

export default CashFlowTable;
